<template>
  <section class="post-info-section">
    <div class="details">
      <span class="campaign-title">Campaign Name goes here</span>
      <h2>{{ deliverableDetail.title }}</h2>
      <hr />
    </div>
    <div class="details">
      <div class="row">
        <div class="col-md-5">
          <h3>Engagement Manager</h3>
          <span>Insert Name</span>
        </div>
        <div class="col-md-5">
          <h3>People</h3>
          <ul class="people-list">
            <li>Person One</li>
            <li>Person Two</li>
            <li>Person Three</li>
            <li>Person Four</li>
            <li>Person Five</li>
            <li>Person Six</li>
          </ul>
        </div>
        <div class="col-md-2">
          <h3>Post Status</h3>
          <span>Status</span>
        </div>
      </div>
    </div>
    <div class="details summary">
      <h3>Post Summary</h3>
      <div class="summary-list languages">
        <span>Languages</span>
        <span class="lang">en</span>
        <span class="lang">fr</span>
      </div>
      <div class="summary-list platforms">
        <span>Platforms</span>
        <span class="platform twitter"><i class="fab fa-x-twitter"></i></span>
        <span class="platform facebook"><i class="fab fa-facebook"></i></span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      
    };
  },
  components: {
    
  },
  props: ["socialPost"],
  
  computed: {
    ...mapGetters([
      "deliverableDetail",
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    dummyFunction() {
    	return "";
    },
  }
}

</script>